// extracted by mini-css-extract-plugin
module.exports = {"container":"TopHeaderSP_container__mutqg","flex":"TopHeaderSP_flex__261BK","logo":"TopHeaderSP_logo__2Z1Jb"};